import React from 'react';

const ProjectCard = ({ project, onClick }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  return (
    <div className="card" onClick={onClick} style={styles.card}>
      <div style={styles.cardHeader}>
        <h3 style={styles.projectName}>{project.name}</h3>
        <span style={styles.arrow}>→</span>
      </div>
      <p style={styles.date}>Created: {formatDate(project.createdAt)}</p>
      <div style={styles.footer}>
        <span style={styles.footerText}>Click to view details</span>
      </div>
    </div>
  );
};

const styles = {
  card: {
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '10px',
  },
  projectName: {
    fontSize: '20px',
    fontWeight: '600',
    color: 'var(--text-primary)',
    margin: 0,
  },
  arrow: {
    fontSize: '24px',
    color: 'var(--text-primary)',
    transition: 'transform 0.2s ease',
  },
  date: {
    color: 'var(--text-secondary)',
    fontSize: '14px',
    marginBottom: '15px',
  },
  footer: {
    borderTop: '1px solid var(--border-color)',
    paddingTop: '15px',
  },
  footerText: {
    color: 'var(--text-secondary)',
    fontSize: '13px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
};

export default ProjectCard;

